import { getUID } from '@redviking/argonaut-util/src/getUID';
import { getAppletEvents } from '@redviking/argonaut-util/src/mes/get-applet-events';
import type { UiNodeSpec } from './UiNodeSpec';

export const appletEventListenUiNodeSpec: UiNodeSpec<'appletEventListen'> = {
    requiredSockets: 'all',
    cfg: () => ({ controlValues: { appletEventId: '' }, id: getUID(), kind: 'appletEventListen', disabled: false }),
    controls: getNodeCfg => ({
        appletEventId: {
            cfg: {
                kind: 'selectEvent',
            },
            nodeCfg: getNodeCfg(),
            value: getNodeCfg().controlValues.appletEventId,
        },
    }),
    inputs: () => ({}),
    kindLabel: 'Listen For Applet Event',
    nodeCategory: 'events',
    outputs: () => ({ event: { socket: 'event', label: 'Event' } }),
    validator: (node, appletDesignVersionConfig) => {
        const events = getAppletEvents(appletDesignVersionConfig);
        const validEventNames = Object.keys(events);
        const errors: Record<string, string> = {};
        if (!node.controlValues.appletEventId) {
            errors.appletEventId = 'Event ID is required';
        }
        if (!validEventNames.includes(node.controlValues.appletEventId)) {
            errors.appletEventId = 'Event ID is not a valid event';
        }

        return Object.keys(errors).length ? errors : true;
    },
};
